import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppLayout } from './components/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { MeetingsPage } from './pages/MeetingsPage';
import { MeetingSeriesPage } from './pages/MeetingSeriesPage';
import { MeetingInstancePage } from './pages/MeetingInstancePage';
import { TasksPage } from './pages/TasksPage';
import { TagsPage } from './pages/TagsPage';
import { PeoplePage } from './pages/PeoplePage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/meetings" element={<MeetingsPage />} />
              <Route path="/meetings/:seriesId" element={<MeetingSeriesPage />} />
              <Route path="/meetings/:seriesId/:instanceId" element={<MeetingInstancePage />} />
              <Route path="/tasks" element={<TasksPage />} />
              <Route path="/tags" element={<TagsPage />} />
              <Route path="/people" element={<PeoplePage />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
